import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Header } from './components/layout/Header';
import { SeoStatement } from './components/layout/SeoStatement';
import { Footer } from './components/layout/Footer';
import { ScrollToHash } from './components/layout/ScrollToHash';
import { Home } from './pages/Home';
import { Portfolio } from './pages/Portfolio';
import { PricingPlan } from './pages/PricingPlan';
import { NotFound } from './pages/NotFound';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2mjzlb0sxjhkg">
      <BrowserRouter data-id="element-1" data-mp="31ayqs2ygxpzt">
        <div className="w-full min-h-screen bg-ink font-sans text-white antialiased selection:bg-forge-orange/40" data-id="element-2" data-mp="31bi8bik7icdb">
          <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-forge-orange focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-ink" data-id="element-3" data-mp="2wip734ny5m5z">
            Skip to content
          </a>
          <ScrollToHash data-id="element-4" data-mp="3ijpef4c7z5bc" />
          <SeoStatement data-id="element-5" data-mp="3mlj98vzqhf3l" />
          <Header data-id="element-6" data-mp="3mkrefndynled" />
          <main id="main" data-id="element-7" data-mp="3mk852v2dm5by">
            <Routes data-id="element-8" data-mp="3mjga9mglsbmq">
              <Route path="/" element={<Home data-id="element-10" data-mp="3rbzmog3k10py" />} data-id="element-9" data-mp="3rc9ca2kot5v4" />
              <Route path="/portfolio" element={<Portfolio data-id="element-12" data-mp="3relumgucxi8p" />} data-id="element-11" data-mp="3rdkl4gszp3t3" />
              <Route path="/pricing" element={<PricingPlan data-id="element-14" data-mp="4n6o4eeqtbm" />} data-id="element-13" data-mp="6hp9c27i9cj" />
              <Route path="/pricing-plan" element={<Navigate to="/pricing" replace data-id="element-16" data-mp="2zlld2w2kqak3" />} data-id="element-15" data-mp="7su7f7e1n58" />
              <Route path="*" element={<NotFound data-id="element-18" data-mp="33movnqc0akp0" />} data-id="element-17" data-mp="2zn69yscd25l4" />
            </Routes>
          </main>
          <Footer data-id="element-19" data-mp="33mymth8sexwa" />
        </div>
      </BrowserRouter>
    </MotionConfig>;
}